<div class="home-page">
  <app-pwa-install-banner></app-pwa-install-banner>

  @if (isLoggedIn | async) {
    @if (isVerified$ | async) {
      <app-announcements></app-announcements>
    }
    @if (subscriptionsFlagEnabled) {
      <app-subscription-banner></app-subscription-banner>
    }
  }

  <div class="hero-section">
    <div class="hero-bg"></div>
    <div class="hero-content">
      @if (userFirstName) {
        <p class="greeting">{{ 'Welcome back' | translate }}, {{ userFirstName }}.</p>
      } @else {
        <p class="greeting">{{ 'Welcome' | translate }}.</p>
      }
      <p class="welcome-subtitle">
        @if (welcomeMessage) {
          {{ welcomeMessage }}
        }
      </p>

      <div class="hero-actions">
        @if (isLoggedIn | async) {
          @if (showCalendar || showEventsTab) {
            <button class="book-btn" (click)="onBookNow(true)">
              <mat-icon class="btn-icon">arrow_forward</mat-icon>
              @if (showCalendar) {
                {{ 'Book Now' | translate }}
              } @else {
                {{ 'View Events' | translate }}
              }
            </button>
          }

          @if (activelyLinkEnabled) {
            @if (!isSearching) {
              <div class="play-btn-wrapper">
                <button
                  class="play-btn"
                  [class.play-btn--disabled]="!pushNotificationsEnabled"
                  [disabled]="!pushNotificationsEnabled"
                  (click)="onPlayToday()"
                >
                  <mat-icon class="btn-icon">auto_awesome</mat-icon>
                  {{ 'Play Today' | translate }}
                </button>
                @if (!pushNotificationsEnabled) {
                  <div class="play-btn-tooltip">
                    <mat-icon class="tooltip-icon">notifications_off</mat-icon>
                    <span>{{ 'matchmaking_notifications_required' | translate }}</span>
                  </div>
                }
              </div>
            } @else {
              <button class="play-btn play-btn--searching" (click)="cancelSearch()">
                <mat-icon class="btn-icon">close</mat-icon>
                {{ 'Cancel Search' | translate }}
              </button>
              <p class="searching-hint">
                <mat-icon class="hint-icon">notifications_active</mat-icon>
                {{ 'matchmaking_hint' | translate }}
              </p>
            }
          }
        } @else {
          @if (showCalendar || showEventsTab) {
            <button class="book-btn" (click)="onBookNow(false)">
              <mat-icon class="btn-icon">arrow_forward</mat-icon>
              @if (showCalendar) {
                {{ 'Book Now' | translate }}
              } @else {
                {{ 'View Events' | translate }}
              }
            </button>
          }
        }

        @if (showSuggestFeature) {
          <button class="suggest-btn" (click)="navigateTo(suggestIdea)">
            <mat-icon class="btn-icon">lightbulb_outline</mat-icon>
            {{ 'Suggest a feature!' | translate }}
          </button>
        }
      </div>
    </div>
  </div>

  @if (activelyLinkEnabled) {
    <app-matchmaking-dialog
      [(visible)]="showMatchDialog"
      (confirm)="onMatchConfirm($event)"
    ></app-matchmaking-dialog>
  }

  @if (showPlayerId && userId && userFullName) {
    <app-player-id-card
      [userId]="userId"
      [userName]="userFullName"
    ></app-player-id-card>
  }

  <app-homepage-widgets></app-homepage-widgets>

  @if (isLoggedIn | async) {
    <app-my-next-match />
  }

  @if (showSponsors) {
    <app-sponsors-carousel></app-sponsors-carousel>
  }
</div>
